import {compareDesc, parseISO} from 'date-fns';

import type {InterestTimelineEvent} from '@prompt-bridge/shared/ai-assistant-core';

export const compareInterestTimelineEventsNewestFirst = (
  left: InterestTimelineEvent,
  right: InterestTimelineEvent
) =>
  compareDesc(parseISO(left.occurredAt), parseISO(right.occurredAt)) ||
  left.id.localeCompare(right.id);
